export default "__VITE_ASSET__d275b7c7__"